class InspirationSidebar {
  public items: HTMLCollection;
  public closeButtons: HTMLCollection;
  public sidebarXsToggler: HTMLCollection;

  bindings() {
    if (this.items) {
      window.innerWidth > 768 &&
        window.addEventListener('scroll', () => {
          let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
          let sidebar = document.querySelector('.o-tabs__content.is--active .js-o-sidebar');

          if (sidebar && !sidebar.classList.contains('o-sidebar--is-closed')) {
            if (winScroll > 100) sidebar.classList.add('o-sidebar--is-visible');
            else sidebar.classList.remove('o-sidebar--is-visible');
          }
        });

      window.innerWidth < 769 &&
        window.addEventListener('scroll', () => {
          let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
          let sidebarToggle = document.querySelector('.o-tabs__content.is--active .o-sidebar__xs-toggler');

          if (sidebarToggle) {
            if (winScroll > 100) sidebarToggle.classList.add('o-sidebar__xs-toggler--is-visible');
            else sidebarToggle.classList.remove('o-sidebar__xs-toggler--is-visible');
          }
        });
    }

    if (this.closeButtons) {
      Object.values(this.closeButtons).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          let sidebar = e.target.closest('.o-sidebar');
          sidebar.classList.toggle('o-sidebar--is-visible');
          sidebar.classList.add('o-sidebar--is-closed');
          e.preventDefault();
          return false;
        });
      });
    }

    if (this.sidebarXsToggler) {
      Object.values(this.sidebarXsToggler).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          e.target.nextElementSibling.classList.add('o-sidebar--is-visible');
          e.preventDefault();
          return false;
        });
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('js-o-sidebar');
    this.closeButtons = document.getElementsByClassName('js-o-sidebar-toggler');
    this.sidebarXsToggler = document.getElementsByClassName('js-o-sidebar__xs-toggler');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default InspirationSidebar;
